import { MeterVerificationStateService } from '@account/login/meterVerificationState.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AppConsts } from '@shared/AppConsts';
import { UserServiceProxy } from '@shared/service-proxies/service-proxies';

@Injectable()
export class MeterVerificationGuard implements CanActivate {
    constructor(
        private meterState: MeterVerificationStateService,
        private _router: Router,
        private _userService: UserServiceProxy
    ) {}

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        return this.checkStatus(state);
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        return this.checkStatus(state);
    }

    private checkStatus(state: RouterStateSnapshot): boolean | UrlTree {
        this.meterState.loadFromStorage();
        const status = this.meterState.status;
        const allowedUrl = '/app/admin/portfolioManagement/meterInfos';

        if (state.url.startsWith(allowedUrl)) return true;
        if (status === true || status === null) return true;

        this._userService.getUserForView(abp.session.userId).subscribe((org) => {
            this._router.navigate(['/app/admin/portfolioManagement/meterInfos'], {
                queryParams: { orgId: org.organizationUnitId },
            });
        });
        return false;
    }
}
